module.exports = __webpack_public_path__ + "static/media/STHiFi2.45ae6aa4.png";